export const Tabs = ({ name, on, onClick }) => (
    <div
        onClick={onClick}
        className={`flex items-center h-100 px-5 cursor-pointer pb-3 ${on ? 'border-primary border-b-[2px] text-primary font-bold' : ''}`}>
        <span className='capitalize'> {name}</span></div>
)